import { useQuery } from '@tanstack/react-query';
import api from '../axiosAPI';

/**
 * Hook customizado para gerenciar planos
 */
export const usePlans = () => {
  // Query para buscar todos os planos
  const { data, isLoading, error } = useQuery({
    queryKey: ['plans'],
    queryFn: async () => {
      const response = await api.get('/plans', {
        params: {
          ids: [1, 2, 3, 4]
        }
      });
      return response.data;
    },
    retry: 1,
  });  

  return {
    plans: data?.plans || [],
    isLoading,
    error,
  };
};
